export const OWN = [
    'ОАО',
    'ЗАО',
    'АО',
    'ООО',
    'ИП',
    'ПАО'
]